import { Component, inject, input, signal } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LanguageService } from '../../services/language/language.service';
import { NavigationPipe } from '../../pipes/navigation/navigation.pipe';
import { AuthService } from '../../services/auth/auth.service';
import { Path } from '../../constants/paths.constant';
import { LogoComponent } from '../logo/logo.component';
import { MainService } from '../../services/main/main.service';
import { UserInfoComponent } from '../user-info/user-info.component';
import {
  GlobeIconComponent,
  HamburgerMenuIconComponent,
  CloseMenuIconComponent,
} from '@mars/ui-components';

@Component({
  selector: 'mars-top-navbar',
  imports: [
    TranslocoPipe,
    RouterLink,
    RouterLinkActive,
    NavigationPipe,
    LogoComponent,
    UserInfoComponent,
    GlobeIconComponent,
    HamburgerMenuIconComponent,
    CloseMenuIconComponent,
  ],
  templateUrl: './top-navbar.component.html',
  styleUrl: './top-navbar.component.scss',
})
export class TopNavbarComponent {
  private readonly languageService = inject(LanguageService);
  private readonly translocoService = inject(TranslocoService);
  protected readonly authService = inject(AuthService);
  protected readonly mainService = inject(MainService);
  private readonly router = inject(Router);
  private readonly navigationPipe = new NavigationPipe();

  isInLanding = input(true);

  protected readonly Path = Path;

  lang = this.languageService.currentLang;
  isMobileNavbarOpened = false;

  navbarLinks = [
    {
      label: this.translocoService.translate('top_navbar_section_about_link'),
      path: Path.ABOUT,
    },
    {
      label: this.translocoService.translate(
        'top_navbar_section_features_link'
      ),
      path: Path.FEATURES,
    },
    {
      label: this.translocoService.translate(
        'top_navbar_section_become_a_supplier_link'
      ),
      path: Path.BECOME_SUPPLIER,
    },
    {
      label: this.translocoService.translate(
        'top_navbar_section_contact_us_link'
      ),
      path: Path.CONTACT_US,
    },
  ];

  isLoggingOut = signal(false);

  switchLanguage() {
    if (!this.authService.isLoggedIn()) {
      this.languageService.switchLanguage();
      return;
    }

    // Persist the choice first (api 4.md §1) and only switch once the account
    // is actually set to it — a refusal leaves the UI in the language that
    // still matches what's stored, rather than flipping to one the account
    // never got set to. `errorInterceptor` already toasts the failure.
    const nextLang = this.languageService.nextLang() as 'en' | 'ar';
    this.authService.updateLanguage(nextLang).subscribe({
      next: () => this.languageService.switchLanguage(),
    });
  }

  toggleMobileNavbar() {
    this.isMobileNavbarOpened = !this.isMobileNavbarOpened;
  }

  logout() {
    this.authService.logoutAction();
  }
}
